const insightExplorer = {
  INSIGHT_EXPLORER_SELF: ['INSIGHT_EXPLORER_SELF'] as const,
  INSIGHT_EXPLORER_CHILDREN: ['INSIGHT_EXPLORER_CHILDREN'] as const,
  INSIGHT_EXPLORER_TREES: ['INSIGHT_EXPLORER_TREES'] as const,
  INSIGHT_EXPLORER_WORD_CLOUD: ['INSIGHT_EXPLORER_WORD_CLOUD'] as const,
};

export default insightExplorer;
